/**
 * Qty Limit — PDP, Quick-Cart & Main-Cart Enforcement
 *
 * Initial load: fetches /cart.js once to set PDP button state.
 * After that, all surfaces react to `cart:updated`,
 * consuming evt.detail.cart — no further fetches.
 */
(function () {
  'use strict';

  var lastCart = null;

  function getProductQtyInCart(cart, productId) {
    var total = 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].product_id === productId) {
        total += cart.items[i].quantity;
      }
    }
    return total;
  }

  function applyPdpLimit(cart) {
    lastCart = cart;

    var form = document.querySelector('[data-product-form][data-qty-limit]');
    if (!form) return;

    var limit = parseInt(form.getAttribute('data-qty-limit'), 10);
    if (!limit || limit <= 0) return;

    var productId = parseInt(form.getAttribute('data-product-id'), 10);
    if (!productId) return;

    var btn = form.querySelector('[data-add-to-cart]');
    if (!btn) return;

    var textEl = btn.querySelector('[data-add-to-cart-text]');
    var inCart = getProductQtyInCart(cart, productId);

    if (inCart >= limit) {
      btn.disabled = true;
      btn.classList.add('qty-limit-reached');
      if (textEl) textEl.textContent = 'Limit Reached';
    } else {
      btn.disabled = false;
      btn.classList.remove('qty-limit-reached');
      if (textEl) textEl.textContent = btn.getAttribute('data-lang-available') || 'Add to Bag';
    }
  }

  function initialPdpCheck() {
    var hasPdp = document.querySelector('[data-product-form][data-qty-limit]');
    var hasCartItem = document.querySelector('[data-input-item][data-qty-limit]');
    if (!hasPdp && !hasCartItem) return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        applyPdpLimit(cart);
        enforceCartLimits(cart);
      })
      .catch(function (err) {
        console.warn('[qty-limit] cart fetch failed', err);
      });
  }

  function enforceCartLimits(cart) {
    var items = document.querySelectorAll('[data-input-item][data-qty-limit]');
    if (!items.length) return;

    var productTotals = {};
    for (var i = 0; i < cart.items.length; i++) {
      var pid = cart.items[i].product_id;
      productTotals[pid] = (productTotals[pid] || 0) + cart.items[i].quantity;
    }

    items.forEach(function (el) {
      var limit = parseInt(el.getAttribute('data-qty-limit'), 10);
      var productId = parseInt(el.getAttribute('data-product-id'), 10);
      if (!limit || !productId) return;

      var total = productTotals[productId] || 0;
      var plusBtn = el.querySelector('[data-add-quantity]');

      if (total >= limit) {
        if (plusBtn) {
          plusBtn.disabled = true;
          plusBtn.setAttribute('aria-disabled', 'true');
          plusBtn.classList.add('qty-limit-disabled');
        }
      } else {
        if (plusBtn) {
          plusBtn.disabled = false;
          plusBtn.removeAttribute('aria-disabled');
          plusBtn.classList.remove('qty-limit-disabled');
        }
      }
    });
  }

  function clampInput(target) {
    var item = target.closest('[data-input-item][data-qty-limit]');
    if (!item) return;

    var limit = parseInt(item.getAttribute('data-qty-limit'), 10);
    var productId = parseInt(item.getAttribute('data-product-id'), 10);
    if (!limit || !productId || !lastCart) return;

    // defaultValue reflects the server-rendered quantity; fresh after each section refresh
    var serverLineQty = parseInt(target.defaultValue, 10) || 0;
    var productTotal = getProductQtyInCart(lastCart, productId);
    var otherVariantsQty = productTotal - serverLineQty;
    var maxAllowed = Math.max(1, limit - otherVariantsQty);

    var typed = parseInt(target.value, 10);
    if (!isNaN(typed) && typed > maxAllowed) {
      target.value = maxAllowed;
    }
  }

  // Capture phase — runs before theme.js change-bubble handler that calls cart.updateItem
  document.addEventListener('input', function (evt) {
    if (evt.target && evt.target.matches('[data-quantity-input]')) {
      clampInput(evt.target);
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialPdpCheck);
  } else {
    initialPdpCheck();
  }

  document.addEventListener('cart:updated', function (evt) {
    if (evt.detail && evt.detail.cart) {
      applyPdpLimit(evt.detail.cart);
      enforceCartLimits(evt.detail.cart);
    }
  });

  document.addEventListener('product:variant-change', function () {
    if (lastCart) applyPdpLimit(lastCart);
  });
})();
